import {
  Box,
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SupportIcon from '@mui/icons-material/Support';
import { useState } from 'react';

const supportInfo = [
  {
    icon: <EmailIcon sx={{ color: '#F9B233' }} />,
    title: 'Email Support',
    details: 'support@restro360.com',
    description: 'Get help via email',
  },
  {
    icon: <PhoneIcon sx={{ color: '#F9B233' }} />,
    title: 'Phone Support',
    details: '+1 (555) 123-4567',
    description: '24/7 phone support',
  },
  {
    icon: <LocationOnIcon sx={{ color: '#F9B233' }} />,
    title: 'Office Location',
    details: '123 Restaurant Street, Foodville, FL 12345',
    description: 'Visit our office',
  },
  {
    icon: <AccessTimeIcon sx={{ color: '#F9B233' }} />,
    title: 'Business Hours',
    details: 'Monday - Friday: 9:00 AM - 6:00 PM EST',
    description: "We're here to help",
  },
];

function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    restaurantName: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted', formData);
  };

  return (
    <Box sx={{ bgcolor: '#fff8ec', minHeight: '100vh', py: { xs: 4, md: 8 } }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="stretch">
          {/* Left: Support Info */}
          <Grid item xs={12} md={5}>
            <Card sx={{ bgcolor: '#fff', border: '1.5px solid #F9B233', boxShadow: '0 2px 12px rgba(249,178,51,0.06)' }}>
              <CardContent sx={{ p: 4 }}>
                <Typography variant="h4" sx={{ color: '#234734', fontWeight: 700, mb: 2 }}>
                  Contact Information
                </Typography>
                <List>
                  {supportInfo.map((info, index) => (
                    <ListItem key={index} sx={{ py: 2 }}>
                      <ListItemIcon sx={{ color: 'primary.main' }}>{info.icon}</ListItemIcon>
                      <ListItemText
                        primary={info.title}
                        secondary={
                          <>
                            <Typography component="span" variant="body1" color="text.primary">
                              {info.details}
                            </Typography>
                            <br />
                            {info.description}
                          </>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
                <Box sx={{ mt: 4, bgcolor: '#F9B233', color: '#234734', borderRadius: 2, p: 3, textAlign: 'center' }}>
                  <SupportIcon sx={{ fontSize: 40, mb: 1 }} />
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    Need Immediate Help?
                  </Typography>
                  <Typography>
                    Our support team is available 24/7 to assist you with any questions or issues you may have.
                  </Typography>
                  <Button
                    variant="contained"
                    sx={{ mt: 2, bgcolor: '#234734', color: '#F9B233', fontWeight: 700, '&:hover': { bgcolor: '#234734', color: '#fff8ec' } }}
                    fullWidth
                  >
                    Start Live Chat
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Right: Contact Form */}
          <Grid item xs={12} md={7}>
            <Card sx={{ bgcolor: '#fff8ec', border: '1.5px solid #F9B233', boxShadow: '0 2px 12px rgba(249,178,51,0.06)' }}>
              <CardContent sx={{ p: 4 }}>
                <Typography variant="h4" gutterBottom sx={{ color: '#234734', fontWeight: 700 }}>
                  Send us a Message
                </Typography>
                <form onSubmit={handleSubmit}>
                  <Stack spacing={2}>
                    <TextField
                      required
                      fullWidth
                      label="First Name"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                    />
                    <TextField
                      required
                      fullWidth
                      label="Last Name"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                    />
                    <TextField
                      required
                      fullWidth
                      label="Email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    <TextField
                      required
                      fullWidth
                      label="Phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                    <TextField
                      required
                      fullWidth
                      label="Restaurant Name"
                      name="restaurantName"
                      value={formData.restaurantName}
                      onChange={handleChange}
                    />
                    <TextField
                      required
                      fullWidth
                      label="Message"
                      name="message"
                      multiline
                      rows={4}
                      value={formData.message}
                      onChange={handleChange}
                    />
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        bgcolor: '#F9B233',
                        color: '#234734',
                        fontWeight: 700,
                        px: 4,
                        py: 1.5,
                        borderRadius: 2,
                        boxShadow: '0 2px 8px rgba(249,178,51,0.10)',
                        '&:hover': { bgcolor: '#ffe1a6', color: '#234734' },
                      }}
                      size="large"
                      fullWidth
                    >
                      Send Message
                    </Button>
                  </Stack>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Contact; 